// ImageModal.js
import React from "react";
import { Modal } from "antd";
import ImageGallery from "../ImageGallery/index";

const ImageModal = ({ visible, images, onSelect, onClose }) => {
  return (
    <Modal
      visible={visible}
      title="Select an Image"
      onCancel={onClose}
      footer={null}
    >
      <ImageGallery images={images} onSelect={onSelect} />
    </Modal>
  );
};

export default ImageModal;
